// Unpublished Work © 2023-2025 Deere & Company.

import {
    SET_CROSS_REFERENCE_DATA,
    UPDATE_CROSS_REFERENCE_LOADING_STATUS
} from '../../action-list';
import {CrossReferences} from '../../state/struct/profile/cross-references';
import {PageStatus} from '../../state/struct/page-status';

const updateCrossReferenceLoadingStatus = (state, action) =>
    CrossReferences.update(state, {
        crossReferencesStatus: {
            $set: action.status
        }
    });

const setCrossReferenceData = (state, action) =>
    CrossReferences({
        allCrossReferences: action.crossReferenceDetails.allCrossReferences,
        numberOfCrossReferences: action.crossReferenceDetails.numberOfCrossReferences,
        crossReferencesStatus: PageStatus.meta.map.COMPLETE
    });

export function crossReferences(state = new CrossReferences({}), action = {}) {
    const actionHandlers = {
        [SET_CROSS_REFERENCE_DATA]: setCrossReferenceData,
        [UPDATE_CROSS_REFERENCE_LOADING_STATUS]: updateCrossReferenceLoadingStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
